@if(display()) {
  <ion-item lines="full"  routerLink="/inventory/beer/details/{{ beverage?.id }}">
    @if (beverage?.image) {
      <ion-thumbnail slot="end">
        <img [src]="beverage?.image" />
      </ion-thumbnail>
    }
    <!-- <ion-thumbnail slot="end">
    <img src="/assets/icons/flat/beer/cans/beer-can.svg" />
  </ion-thumbnail> -->
  <ion-label>
    {{ beverage?.name }}
    <div class="ps-badge-list">
      <ion-badge>
        Cans: {{ can?.count }}
      </ion-badge>
      <ion-badge>
        Size: {{ can?.size }}
      </ion-badge>
      @if (can?.notificationDate) {
        <ion-badge
        [color]="{
          'danger': dateHelper.lessThanOrEqualTo(
            can?.notificationDate,
            today
          )
        }"
          >
          <ion-icon name="notifications-outline"></ion-icon>
          Notification:
          {{ dateHelper.calendar(can?.notificationDate) }}
        </ion-badge>
      }
      @if (can?.bestBeforeDate) {
        <ion-badge
        [color]="{
          'danger': dateHelper.lessThanOrEqualTo(
            can?.bestBeforeDate,
            today
          )
        }"
          >
          <ion-icon name="calendar-clear-outline"></ion-icon>
          BBF:
          {{
          dateHelper.formatDate(can?.bestBeforeDate, "MMMM yyyy")
          }}
        </ion-badge>
      }
    </div>
  </ion-label>
</ion-item>
}
